import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, BookOpen } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const FeaturedArticle = () => {
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/articles`);
        const featured = response.data.find(a => a.slug === 'how-to-choose-your-wedding-theme');
        setArticle(featured || null);
      } catch (error) {
        console.error('Failed to load content:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchArticle();
  }, []);

  if (loading || !article) return null;

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-4">
          <p
            className="text-base md:text-lg mb-4 italic"
            style={{ fontFamily: '"Playfair Display", serif', color: '#DE92A9' }}
          >
            From the blog
          </p>
          <h2 
            className="text-4xl md:text-5xl lg:text-6xl mb-6 tracking-tight"
            style={{ fontFamily: '"Playfair Display", serif', color: '#2C2C2C' }}
          >
            Featured Article
          </h2>
        </div>

        <Link 
          to={`/tips-inspiration/${article.slug}`}
          className="group block"
          data-testid="featured-article-link"
        >
          <div className="grid md:grid-cols-2 gap-0 bg-[#FAF9F7] rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500">
            {/* Image */}
            <div className="relative h-[300px] md:h-[450px] overflow-hidden">
              <img 
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              loading="lazy"
              decoding="async"
              />
              <div className="absolute top-4 left-4 bg-[#DE92A9] text-white text-xs px-3 py-1.5 rounded tracking-wider">
                FEATURED
              </div>
            </div>

            {/* Content */}
            <div className="p-8 md:p-12 flex flex-col justify-center">
              <div className="flex items-center gap-4 text-xs text-[#757B7F] mb-4">
                <span className="flex items-center gap-1">
                  <Clock size={14} />
                  {article.date}
                </span>
                <span className="flex items-center gap-1">
                  <BookOpen size={14} />
                  8 min read
                </span>
                <span className="bg-[#DE92A9]/10 text-[#DE92A9] px-2 py-0.5 rounded text-xs">
                  {article.category}
                </span>
              </div>
              
              <h3 
                className="text-2xl md:text-3xl text-[#2C2C2C] mb-4 leading-tight group-hover:text-[#DE92A9] transition-colors"
                style={{ fontFamily: '"Playfair Display", serif' }}
              >
                {article.title}
              </h3>
              
              <p className="text-[#757B7F] text-base leading-relaxed mb-8 line-clamp-6">
                {article.excerpt}
              </p>
              
              <div className="flex items-center text-sm font-medium tracking-wider group-hover:gap-3 transition-all" style={{ color: '#DE92A9' }}>
                READ FULL ARTICLE
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
              </div>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default FeaturedArticle;
